import { render } from "./booking-coaches-modal.vue?vue&type=template&id=2cd3a0f6"
import script from "./booking-coaches-modal.vue?vue&type=script&lang=js"
export * from "./booking-coaches-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__